export default {
  goTo: {
    en: '“{product}” product page',
  },
  addTo: {
    en: 'Add “{product}” to queue',
  },
}
